import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DialogRef } from '../dialog-ref';
import { ElementsModule } from '@shared/elements/elements.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'pay-dialog-loader',
    templateUrl: './dialog-loader.component.html',
    standalone: true,
    imports: [
        TranslateModule,
        ElementsModule
    ],
    host: {
        'class': 'c-dialog c-dialog--loader active',
        '[class.in]': 'isReady'
    }
})
export class DialogLoaderComponent implements OnInit {
    public config;
    public isReady: boolean = false;

    constructor(public dialogRef: DialogRef<DialogLoaderComponent>,
                private cdr: ChangeDetectorRef) {
        this.config = dialogRef.containerInstance.config;
    }

    ngOnInit() {
        this.isReady = true;
        this.cdr.markForCheck();
    }

    /**
     * Process confirmed request and close.
     */
    process() {
        if (this.config.process) {
            this.config.process();
        }

        this.dialogRef.close(true);
    }
}
